import 'components/shared/Buttons/GridCellButtons.scss';

import React, { useState } from 'react';

import { isBrokerage } from 'services/Products';
import {
  getAccountTransactionUrls,
  getAccountTransactionUrlsLinkGroup
} from 'services/Externals';
import { openBrokerageAuthTab } from 'services/ExternalAuthorizationURLBuilder';
import ClickOffSensor from 'components/shared/ClickOffSensor/ClickOffSensor';
import {
  BrokerageActionLinksWithPermissions,
  brokerageActions,
  LinkGroup
} from 'components/layouts/TransactionsModal/TransactionsModal';
import { ReactComponent as MoreElipsis } from 'assets/icons/more-elipsis.svg';
import { AAMBeaconIconButton } from 'components/shared/Beacon';

export const TransactionButton = ({ accountId, productType }) => {
  let label = '';
  let url = undefined;
  const transactionUrls = getAccountTransactionUrls(productType, accountId);
  const primaryLabelAndUrl =
    transactionUrls && transactionUrls.length > 0 ? transactionUrls[0] : {};

  if (isBrokerage(productType)) {
    label = 'Trade';
  } else {
    label = primaryLabelAndUrl.label;
    url = primaryLabelAndUrl.link;
  }

  return (
    <a
      href={url}
      onClick={() =>
        isBrokerage(productType)
          ? openBrokerageAuthTab(accountId, 'TRADING')
          : null
      }
      className="cell-transaction-button">
      {label}
    </a>
  );
};

export const MoreButton = ({
  data,
  accountId,
  accountNumber,
  sweepAccountId,
  productType,
  isMobile,
  isAccountDetails,
  isRMDEligible,
  withdrawEnabled
}) => {
  const [show, setShow] = useState(false);
  let links = getAccountTransactionUrlsLinkGroup(
    productType,
    accountId,
    isAccountDetails,
    isRMDEligible
  );

  const open = () => {
    setShow(true);
  };

  const close = () => {
    setShow(false);
  };

  let modalStyling = 'cell-more-modal';
  if (isAccountDetails) {
    modalStyling = 'account-details-more-modal';
  }

  return (
    <ClickOffSensor isOpen={show} onClickOut={close}>
      <AAMBeaconIconButton variant={'secondary'} aria-label="More" onBeaconEventClick={() => (show ? close() : open())}>
        <MoreElipsis slot="icon" />
      </AAMBeaconIconButton>
      {show && (
        <div className={modalStyling}>
          <div className="cell-more-modal-drop-down-content">
            {isBrokerage(productType) ? (
              <BrokerageActionLinksWithPermissions
                brokerageActions={brokerageActions}
                shouldDisable={false}
                accountId={accountId}
                accountNumber={accountNumber}
                sweepAccountId={sweepAccountId}
                accounts={data ? [data] : []}
                isPam={true}
                includeHeader={false}
              />
            ) : (
              <LinkGroup
                label={productType}
                links={links}
                productType={productType}
                includeHeader={false}
                isMobile={isMobile}
                withdrawEnabled={withdrawEnabled}
                isRMDEligible={isRMDEligible}
                isAccountDetails={isAccountDetails}
              />
            )}
          </div>
        </div>
      )}
    </ClickOffSensor>
  );
};
